import {takeLatest, call, put} from "redux-saga/effects";
import * as actions from "../action.constants";
import {
  getGroups,
  listPermissions,
  listUser,
  deleteGroup,
  createGroup,
  editGroup,
} from "../AsyncActions/group.async";
import {updateAddgroupModalData} from "../Actions/group.action";

function* groupRequest(action = {}) {
  const {pageUrl = ""} = action;
  try {
    const response = yield call(getGroups, pageUrl);
    if (response) {
      yield put({type: actions.SAVE_GROUP_LIST, responsePayload: response?.data});
    }
  } catch (e) {
    return e;
  }
}

function* getPermissionList() {
  try {
    const response = yield call(listPermissions);
    if (response) {
      yield put({
        type: actions.SAVE_PERMISSION_LIST,
        responsePayload: response?.data?.results,
      });
    }
  } catch (e) {
    return e;
  }
}

function* getUsersList() {
  try {
    const response = yield call(listUser);
    if (response) {
      yield put({
        type: actions.SAVE_USER_LIST,
        responsePayload: response?.data?.data,
      });
    }
  } catch (e) {
    return e;
  }
}

function* deleteGroupRequest(action = {}) {
  const {payload, callback = () => {}} = action;
  try {
    const response = yield call(deleteGroup, payload);
    if (response) {
      callback();
    }
  } catch (e) {
    return e;
  }
}

function* handleGroupModalResponse() {
  yield put(updateAddgroupModalData({}));
}

function* createGroupRequest(action = {}) {
  const {payload = {}, callback = () => {}} = action;
  try {
    const response = yield call(createGroup, payload);
    if (response) {
      yield call(handleGroupModalResponse);
      callback();
    }
  } catch (e) {
    return e;
  }
}

function* editGroupRequest(action = {}) {
  const {payload = {}, callback = () => {}} = action;

  try {
    const response = yield call(editGroup, payload);
    if (response) {
      yield call(handleGroupModalResponse);
      callback();
    }
  } catch (e) {
    return e;
  }
}

export function* groupSaga() {
  yield takeLatest(actions.REQUEST_GROUP_LIST_SAGA, groupRequest);
  yield takeLatest(actions.REQUEST_PERMISSION_LIST, getPermissionList);
  yield takeLatest(actions.REQUEST_USER_LIST, getUsersList);
  yield takeLatest(actions.REQUEST_DELETE_GROUP_SAGA, deleteGroupRequest);
  yield takeLatest(actions.REQUEST_SEND_ADD_GROUP_DATA_SAGA, createGroupRequest);
  yield takeLatest(actions.REQUEST_SEND_EDIT_GROUP_DATA_SAGA, editGroupRequest);
}
